// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const { authRequired } = require('client-v2/common/state/user/actions')
// Container imports
const interestActions = require('../interest/actions')

function mapStateToProps(state) {
  return {
    interest: state.interest
  }
}

const mapDispatchToProps = {
  onFollowClick: authRequired(
    interestActions.toggleFollowing,
    authModalActions.showSignup
  )
}

module.exports = (
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
